import { SurchargeDisputeDataSchema } from "@redotech/redo-model/balance/surcharge-dispute";
import * as z from "zod/v4";

export const getSurchargeDisputes = {
  name: "getSurchargeDisputes" as const,
  input: z.object({ pageNumber: z.number(), pageSize: z.number() }),
  output: z.object({
    disputes: z.array(SurchargeDisputeDataSchema),
    total: z.number(),
  }),
};
